// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import { Button } from '../styles'
export { Button }
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`
export const HeaderTitle = styled.div`
  margin: 0;
  margin-right: 36px;
  margin-top: 39px;
  @media (max-width: 600px) {
   margin-top: 16px;
  }
`
export const HeaderActions = styled(Row)`
  margin: 0;
  margin-top: 39px;
  justify-content: flex-end;
  width: 100%;
  @media (max-width: 600px) {
    margin-top: -50px;
  }
`
export const HeaderSection = styled(Row)`
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    [data-type='featured-section-curator'] {
      margin-top: -20px;
    }
  }
  [data-type='featured-section-curator'] {
    margin-top: 0px;
  }
`
export const Header = styled(Row)`
  align-items: center;
  margin-bottom: 24px;
  white-space: nowrap;
`